import React from "react";
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { formatWithoutDecimal } from "../../utils/formatWithoutDecimal";

const defaultChartData = [
  { name: "Jan", value: 14 },
  { name: "Feb", value: 18 },
  { name: "Mar", value: 16 },
  { name: "Apr", value: 25 },
  { name: "May", value: 21 },
  { name: "Jun", value: 29 },
  { name: "Jul", value: 27 },
];

const Customers = ({
  title = "Customers",
  value = "0",

  chartId = "customers",
  chartData = defaultChartData,
  className = "",
  customersData,
}) => {
  const monthNames = {
    1: "Jan",
    2: "Feb",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "Jun",
    7: "Jul",
    8: "Aug",
    9: "Sep",
    10: "Oct",
    11: "Nov",
    12: "Dec",
  };
  const apiMonthwise = Array.isArray(customersData?.monthwise_current_financial_year)
    ? customersData.monthwise_current_financial_year
    : [];
  const computedChartData =
    apiMonthwise.length > 0
      ? apiMonthwise.map((item) => ({
          name: monthNames[item?.calendar_month] || String(item?.calendar_month || ""),
          value: Number(item?.total_customers ?? 0),
        }))
      : chartData;
  const computedValue = Number(customersData?.total_customers ?? value ?? 0);

  return (
    <div className={`col-lg-3 col-md-5 col-12 ${className}`.trim()}>
      <div
        className="card shadow-none h-100 border-0"
        style={{
          minHeight: "92px",
          background: "#FFFFFF",
          borderRadius: "18px",
          border: "1px solid #E2E8F0",
        }}
      >
        <div className="card-body px-4 pt-3 pb-2">
          <span
            className="d-block"
            style={{
              fontSize: "0.875rem",
              color: "#334155",
              fontWeight: 500,
              letterSpacing: "0.2px",
            }}
          >
            {title}
          </span>
          <div className="d-flex align-items-baseline gap-2 mt-1">
            <h5
              className="mb-0"
              style={{
                fontSize: "1.85rem",
                fontWeight: 700,
                color: "#0F172A",
                lineHeight: 1,
              }}
            >
              {formatWithoutDecimal(computedValue)}
            </h5>
          </div>
        </div>

        <div
          id={chartId}
          style={{ height: 92, width: "100%", marginTop: "10px" }}
        >
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart
              data={computedChartData}
              margin={{ top: 4, right: 0, left: 0, bottom: 0 }}
            >
              <defs>
                <linearGradient
                  id={`${chartId}-fill`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="5%" stopColor="rgba(37, 99, 235, 0.28)" />
                  <stop offset="95%" stopColor="rgba(37, 99, 235, 0.03)" />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" hide />
              <YAxis hide domain={["dataMin - 4", "dataMax + 4"]} />
              <Tooltip
                cursor={{ stroke: "#CBD5E1", strokeWidth: 1 }}
                formatter={(val) => [
                  formatWithoutDecimal(val),
                  "Customers",
                ]}
                contentStyle={{
                  borderRadius: "10px",
                  border: "1px solid #E2E8F0",
                  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
                }}
              />
              <Area
                type="monotone"
                dataKey="value"
                stroke="#2563EB"
                strokeWidth={2.2}
                strokeLinecap="round"
                fill={`url(#${chartId}-fill)`}
                dot={false}
                activeDot={{ r: 4, strokeWidth: 0 }}
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default Customers;
